import React from "react";
import { connect } from "react-redux";
import styled, { css } from "styled-components";
import { isRtl } from "../../../../i18n/helpers";
import { mapStateToPropsLogin } from "../../../../modules/login";

const UserNameStyled = styled.span`
  ${() =>
    isRtl() &&
    css`
      direction: rtl;
    `}
`;

const UserName = ({ userName, defaultValue = "" }) => {
  return (
    <UserNameStyled className="user-name">
      {userName || defaultValue}
    </UserNameStyled>
  );
};

export default connect(mapStateToPropsLogin)(UserName);
